import { InfoCircleOutlined } from '@ant-design/icons';
import { THEME } from '@common/constants/theme.constant';
import { Tooltip } from '@common/general-ui/tooltip/tooltip.component';
import React from 'react';
import { css } from 'twin.macro';
import { IFieldProps } from './field.component';

export interface IFieldLabelProps {
    label?: IFieldProps<unknown>['label'];
    required?: IFieldProps<unknown>['required'];
    htmlFor?: string;
    className?: string;
    onLabelClick?: () => void;
    tooltip?: string;
}

export const FieldLabel = ({
    label,
    required,
    className,
    htmlFor,
    onLabelClick,
    tooltip,
}: IFieldLabelProps): JSX.Element | null => {
    return (
        <label onClick={onLabelClick} htmlFor={htmlFor} css={styles.root} className={className}>
            {label}
            {tooltip && (
                <Tooltip type="info" title={tooltip}>
                    <InfoCircleOutlined css={styles.info} />
                </Tooltip>
            )}
            {required && <sup css={styles.required}>*</sup>}
        </label>
    );
};
const styles = {
    root: css`
        text-align: left;
        font-size: ${THEME.BASE_FONT_SIZE};
        font-weight: 400;
        color: black;
        display: inline-flex;
        max-width: 100%;
        align-items: baseline;
        padding-bottom: 4px;
    `,
    info: css`
        display: inline-flex;
    `,
    required: css`
        color: #ff3304;
        font-size: 12px;
    `,
};
